// App.jsx - Version: 8.0.0 - Created: 2024-12-08
import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header/Header-v2.1.0.jsx'
import Footer from './components/Footer/Footer-v1.0.0.jsx'
import HomePage from './pages/HomePage/HomePage-v2.0.0.jsx'
import AcademyPage from './pages/Academy/AcademyPage-v1.1.0.jsx'
import PlaygroundPage from './pages/Playground/PlaygroundPage-v2.4.0.jsx';

import PracticePage from './pages/Practice/PracticePage-v2.0.0.jsx'
import ParentsPage from './pages/Parents/ParentsPage-v2.0.0.jsx'
import './App.css'


function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/academy" element={<AcademyPage />} />
            <Route path="/playground" element={<PlaygroundPage />} />
            <Route path="/practice" element={<PracticePage />} />
            <Route path="/parents" element={<ParentsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

// صفحه ۴۰۴
const NotFoundPage = () => (
  <div className="not-found-page">
    <div className="container">
      <h1>۴۰۴ - صفحه پیدا نشد</h1>
      <p>صفحه‌ای که دنبال آن هستید وجود ندارد.</p>
      <a href="/" className="primary-button">بازگشت به خانه</a>
    </div>
  </div>
)

export default App